import { render, staticRenderFns } from "./TilePerformance.vue?vue&type=template&id=0a424968"
import script from "./TilePerformance.vue?vue&type=script&lang=js"
export * from "./TilePerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports